const ShopProducts =[
    {
        id:1,
        Cat:'Blazers',
        Price:'Ksh 1500',
        Img:'/img/longer.jpg'
    }, 
    {
        id:2,
        Cat:'Pallazo pants',
        Price:'Ksh 1500',
        Img:'/img/pallazo2.jpg'
    }, 
    {
        id:3,
        Cat:'Trousers',
        Price:'Ksh 1500',
        Img:'/img/trouser10.jpg'
    }, 
    {
        id:4,
        Cat:'Jumpsuit',
        Price:'Ksh 1250',
        Img:'/img/yellow.jpg'
    },
    {
        id:5,
        Cat:'Trousers',
        Price:'Ksh 1500',
        Img:'/img/trouser1.jpg'
    }, 
    {
        id:6,
        Cat:'Two-piece',
        Price:'Ksh 2500',
        Img:'/img/twopiece.jpg'
    },
    {
        id:7,
        Cat:'Jumpsuit',
        Price:'Ksh 1250',
        Img:'/img/ama.jpg'
    },
    {
        id:8,
        Cat:'Trousers',
        Price:'Ksh 1500',
        Img:'/img/trouser2.jpg'
    }, 
    {
        id:9,
        Cat:'Jumpsuit',
        Price:'Ksh 1250',
        Img:'/img/good.jpg'
    },
    {
        id:10,
        Cat:'Dresses',
        Price:'Ksh 850',
        Img:'/img/dress1.jpg'
    },
    {
        id:11,
        Cat:'Dresses',
        Price:'Ksh 850',
        Img:'/img/dress2.jpg'
    },
    {
        id:12,
        Cat:'Blazers',
        Price:'Ksh 1500',
        Img:'/img/blazer.jpg'
    }, 
    {
        id:13,
        Cat:'Trousers',
        Price:'Ksh 1500',
        Img:'/img/trouser3.jpg'
    }, 
    {
        id:14,
        Cat:'Blazers',
        Price:'Ksh 1500',
        Img:'/img/amazon.jpg'
    }, 
    {
        id:15,
        Cat:'Trousers',
        Price:'Ksh 1500',
        Img:'/img/trouser10.jpg'
    }, 
    {
        id:16,
        Cat:'Blazers',
        Price:'Ksh 1500',
        Img:'/img/Ahla.jpg'
    }, 
    {
        id:17,
        Cat:'Dresses',
        Price:'Ksh 850',
        Img:'/img/dress3.jpg'
    },
    {
        id:18,
        Cat:'Trousers',
        Price:'Ksh 1500',
        Img:'/img/trouser4.jpg'
    }, 
    {
        id:19,
        Cat:'Dresses',
        Price:'Ksh 850',
        Img:'/img/dress4.jpg'
    },
    {
        id:20,
        Cat:'Two-piece',
        Price:'Ksh 2500',
        Img:'/img/zaful.jpg'
    },
    {
        id:21,
        Cat:'Blazers',
        Price:'Ksh 1500',
        Img:'/img/alice.jpg'
    }, 
    {
        id:22,
        Cat:'Jumpsuit',
        Price:'Ksh 1250',
        Img:'/img/look.jpg'
    },
    {
        id:23,
        Cat:'Pallazo pants',
        Price:'Ksh 1500',
        Img:'/img/pallazo3.jpg'
    }, 
    {
        id:24,
        Cat:'Trousers',
        Price:'Ksh 1500',
        Img:'/img/trouser5.jpg'
    }, 
    {
        id:25,
        Cat:'Pallazo pants',
        Price:'Ksh 1500',
        Img:'/img/pallazo4.jpg'
    }, 
    {
        id:26,
        Cat:'Blazers',
        Price:'Ksh 1500',
        Img:'/img/baron.jpg'
    }, 
    {
        id:27,
        Cat:'Two-piece',
        Price:'Ksh 2500',
        Img:'/img/fashiola.jpg'
    },
    {
        id:28,
        Cat:'Jumpsuit',
        Price:'Ksh 1250',
        Img:'/img/lyst.jpg'
    },
    {
        id:29,
        Cat:'Two-piece',
        Price:'Ksh 2500',
        Img:'/img/green.jpg'
    },
    {
        id:30,
        Cat:'Dresses',
        Price:'Ksh 850',
        Img:'/img/dress6.jpg'
    },
    {
        id:31,
        Cat:'Jumpsuit',
        Price:'Ksh 1250',
        Img:'/img/strom.jpg'
    },
    {
        id:32,
        Cat:'Two-piece',
        Price:'Ksh 2500',
        Img:'/img/set.jpg'
    },
    {
        id:33,
        Cat:'Dresses',
        Price:'Ksh 850',
        Img:'/img/dress5.jpg'
    },
    {
        id:34,
        Cat:'Blazers',
        Price:'Ksh 1500',
        Img:'/img/brown.jpg'
    }, 
    {
        id:35,
        Cat:'Pallazo pants',
        Price:'Ksh 1500',
        Img:'/img/pallazo5.jpg'
    }, 
    {
        id:36,
        Cat:'Jumpsuit',
        Price:'Ksh 1250',
        Img:'/img/myth.jpg'
    },
    {
        id:37,
        Cat:'Blazers',
        Price:'Ksh 1500',
        Img:'/img/grayblazer.jpg'
    }, 
    {
        id:38,
        Cat:'Two-piece',
        Price:'Ksh 2500',
        Img:'/img/green.jpg'
    },
    {
        id:39,
        Cat:'Blazers',
        Price:'Ksh 1500',
        Img:'/img/h&m blazer.jpg'
    }, 
    {
        id:40,
        Cat:'Pallazo pants',
        Price:'Ksh 1500',
        Img:'/img/pallazo6.jpg'
    }, 
    {
        id:41,
        Cat:'Jumpsuit',
        Price:'Ksh 1250',
        Img:'/img/new.jpg'
    },
    {
        id:42,
        Cat:'Trousers',
        Price:'Ksh 1500',
        Img:'/img/trouser6.jpg'
    }, 
    {
        id:43,
        Cat:'Jumpsuit',
        Price:'Ksh 1250',
        Img:'/img/nord.jpg'
    },
    {
        id:44,
        Cat:'Dresses',
        Price:'Ksh 850',
        Img:'/img/dress.jpg'
    },
    {
        id:45,
        Cat:'Two-piece',
        Price:'Ksh 2500',
        Img:'/img/zaful.jpg'
    }, 
    {
        id:46,
        Cat:'Dresses',
        Price:'Ksh 850',
        Img:'/img/dress7.jpg'
    },
    {
        id:47,
        Cat:'Pallazo pants',
        Price:'Ksh 1500',
        Img:'/img/pallazo7.jpg'
    }, 
    {
        id:48,
        Cat:'Blazers',
        Price:'Ksh 1500',
        Img:'/img/knighthood.jpg'
    }, 
    {
        id:49,
        Cat:'Two-piece',
        Price:'Ksh 2500',
        Img:'/img/green.jpg'
    },
    {
        id:50,
        Cat:'Blazers',
        Price:'Ksh 1500',
        Img:'/img/lestyle.jpg'
    }, 
    {
        id:51,
        Cat:'Jumpsuit',
        Price:'Ksh 1250',
        Img:'/img/pay.jpg'
    }, 
    {
        id:52,
        Cat:'Pallazo pants',
        Price:'Ksh 1500',
        Img:'/img/pallazo2.jpg'
    }, 
    {
        id:53,
        Cat:'Blazers',
        Price:'Ksh 1500',
        Img:'/img/only blazer.jpg'
    }, 
    {
        id:54,
        Cat:'Blazers',
        Price:'Ksh 1500',
        Img:'/img/parf.jpg'
    }, 
    {
        id:55,
        Cat:'Two-piece',
        Price:'Ksh 2500',
        Img:'/img/zaful.jpg'
    },
    {
        id:56,
        Cat:'Trousers',
        Price:'Ksh 1500',
        Img:'/img/trouser8.jpg'
    }, 
    {
        id:57,
        Cat:'Blazers',
        Price:'Ksh 1500',
        Img:'/img/pinkblazer.jpg'
    }, 
    {
        id:58,
        Cat:'Pallazo pants',
        Price:'Ksh 1500',
        Img:'/img/pallazo1.jpg'
    }, 
    {
        id:59,
        Cat:'Blazers',
        Price:'Ksh 1500',
        Img:'/img/shopstyle.jpg'
    }, 
    {
        id:60,
        Cat:'Two-piece',
        Price:'Ksh 2500',
        Img:'/img/travel.jpg'
    },
    {
        id:61,
        Cat:'Dresses',
        Price:'Ksh 850',
        Img:'/img/dress8.jpg'
    },
    {
        id:62,
        Cat:'Jumpsuit',
        Price:'Ksh 1250',
        Img:'/img/pay.jpg'
    },
    {
        id:63,
        Cat:'Blazers',
        Price:'Ksh 1500',
        Img:'/img/single.jpg'
    }, 
    {
        id:64,
        Cat:'Jumpsuit',
        Price:'Ksh 1250',
        Img:'/img/jumpsuit.jpg'
    },
    {
        id:65,
        Cat:'Blazers',
        Price:'Ksh 1500',
        Img:'/img/Truworths blazer.jpg'
    }, 
    {
        id:66,
        Cat:'Trousers',
        Price:'Ksh 1500',
        Img:'/img/trouser9.jpg'
    }, 
    {
        id:67,
        Cat:'Dresses',
        Price:'Ksh 850',
        Img:'/img/dress6.jpg'
    },
    {
        id:68,
        Cat:'Blazers',
        Price:'Ksh 1500',
        Img:'/img/uk.jpg'
    }, 
    {
        id:69,
        Cat:'Trousers',
        Price:'Ksh 1500',
        Img:'/img/trouser1.jpg'
    }, 
    {
        id:70,
        Cat:'Dresses',
        Price:'Ksh 850',
        Img:'/img/dress4.jpg'
    },
    {
        id:71,
        Cat:'Jumpsuit',
        Price:'Ksh 1250',
        Img:'/img/rack.jpg'
    },
    {
        id:72,
        Cat:'Trousers',
        Price:'Ksh 1500',
        Img:'/img/trouser2.jpg'
    }, 
    {
        id:73,
        Cat:'Blazers',
        Price:'Ksh 1500',
        Img:'/img/womans.jpg'   
    }, 
    {
        id:74,
        Cat:'Dresses',
        Price:'Ksh 850',
        Img:'/img/dress8.jpg'
    },
    {
        id:75,
        Cat:'Jumpsuit',
        Price:'Ksh 1250',
        Img:'/img/jumpsuit.jpg'
    },
    {
        id:76,
        Cat:'Dresses',
        Price:'Ksh 850',
        Img:'/img/dress.jpg'
    },
    {
        id:77,
        Cat:'Blazers',
        Price:'Ksh 1500',
        Img:'/img/blazer.jpg'
    }, 
    {
        id:78,
        Cat:'Trousers',
        Price:'Ksh 1500',
        Img:'/img/trouser3.jpg'
    }, 

    {
        id:79,
        Cat:'Pallazo pants',
        Price:'Ksh 1500',
        Img:'/img/pallazo.jpg'
    }, 
    {
        id:80,
        Cat:'Trousers',
        Price:'Ksh 1500',
        Img:'/img/trouser4.jpg'
    }, 
    {
        id:81,
        Cat:'Pallazo pants',
        Price:'Ksh 1500',
        Img:'/img/pallazo1.jpg'
    }, 
    {
        id:82,
        Cat:'Two-piece',
        Price:'Ksh 2500',
        Img:'/img/twopiece.jpg'
    },
    {
        id:83,
        Cat:'Jumpsuit',
        Price:'Ksh 1250',
        Img:'/img/strom.jpg'
    },

    {
        id:84,
        Cat:'Trousers',
        Price:'Ksh 1500',
        Img:'/img/trouser.jpg'
    }, 
    {
        id:85,
        Cat:'Two-piece',
        Price:'Ksh 2500',
        Img:'/img/green.jpg'
    },

]

export default ShopProducts